import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Row } from 'reactstrap';

//Components
import ListaInfracoes from './Components/ListaInfracoes';

//API
import infracoes_api from '../../../api/infracoes_api';

//Helpers
import { showMessage } from '../../../helpers/message';

//Context
import { useAuth } from '../../../context/auth';

export default function InfracoesList() {
    //State para lista as infrações 
    const [listInfracoes, setListinfracoes] = useState([]);

    //State para visualizar fiscalização
    const [visualizarEtapa_Fiscalizacao, setVisualizarEtapa_Fiscalizacao] = useState(null);

    const { setLoading } = useAuth();

    //Estado que pega os dados passados via navegação
    const location = useLocation();

    //Estado de navegação
    const navigate = useNavigate();

    //pegando a etapa selecionada no dashboard
    const { etapa, tipoFiscalizacao, btnVoltar } = location.state ? location.state : {};

    //Função para dados etapas
    const handleConsultaEtapa = (etapa, tipoFiscalizacao) => {
        setLoading(true)
        infracoes_api.GetListEtapaTipoFiscalizacaoInfracao(etapa, tipoFiscalizacao)
            .then(response => {
                if (response?.data?.length == 0) {
                    showMessage("Error", "Error na operação.", "error", null);
                    return;
                }
                setListinfracoes(response.data);
                setVisualizarEtapa_Fiscalizacao({ etapa: etapa, tipoFiscalizacao: tipoFiscalizacao });
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        if (etapa && tipoFiscalizacao)
            handleConsultaEtapa(etapa, tipoFiscalizacao);
    }, []);

    return <>
        {listInfracoes.length > 0 &&
            <Row>
                <ListaInfracoes
                    handleVoltar={() => navigate(btnVoltar)}
                    listInfracoes={listInfracoes}
                    visualizarEtapaFiscalizacao={visualizarEtapa_Fiscalizacao}
                    setVisualizarEtapaFiscalizacao={setVisualizarEtapa_Fiscalizacao}
                />
            </Row>
        }
    </>;
}